document.addEventListener('DOMContentLoaded', () => {
	// Get cart drawer element
	const cartDrawerEl = document.querySelector('cart-drawer')

	// Return here if no cart drawer element
	if (!cartDrawerEl) return

	// Loop through cart gift checkbox inputs
	cartDrawerEl.querySelectorAll('.js-line-item-giftbox').forEach(cartItemCheckbox => {
		// Cache the line item id form the input data attr line-item
		const checkedItemId = parseInt(cartItemCheckbox.dataset.lineItem)

		// Input change event listener
		cartItemCheckbox.addEventListener('change', event => {
			const checkbox = event.target

			// Disable the input to prevent fetch spamming on value change
			cartItemCheckbox.setAttribute('disabled', 'disabled')

			// Get line item line, quantity and properties from checkbox data attributes
			const itemLine = checkbox.dataset.itemLine
			const itemQuantity = checkbox.dataset.itemQuantity
			const itemProperties = Object.fromEntries(JSON.parse(checkbox.dataset.itemProperties))

			// Set includePackaging var to opposite value of the current line item property 'Gift Packaging'
			const includePackaging = itemProperties['Gift Packaging'] === 'Yes'
				?	'No'
				: 'Yes'

			// Set new properties object using existing line item properties data, updating the 'Gift Packaging' property
			const properties = {
				...itemProperties,
				'Gift Packaging': includePackaging
			}

			// Set data object to pass to cart/change.js endpoint
			const data = {
				'line': itemLine,
				'quantity': itemQuantity,
				'properties': properties
			}

			// Fetch request to cart/change.js
			fetch(`${window.Shopify.routes.root}cart/change.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			})
			.then(response => response.json())
			.then(data => {
				// Update checkbox properties data attr JSON with new properties values
				const datasetProperties = JSON.stringify(Object.keys(properties).map(key => [key, properties[key]]))
				checkbox.dataset.itemProperties = datasetProperties

				// Re-enable the checkbox input
				cartItemCheckbox.removeAttribute('disabled')
			})
			.catch((error) => {
				console.error('Error:', error)
			})
		})
	})
})
